import React from "react";
import { Formik, Form } from "formik";
import Modal from "./modal";
import Input from "./input";
import { editPlaylist } from "../services/api";
import { updatePlaylistAction } from "../actions/playlists";
import cn from "classnames";

const RenamePlaylistModal = ({ isOpen, onCloseModal, playlist, dispatch }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onCloseModal}
      shouldCloseOnEsc={false}
    >
      <Formik
        initialValues={{ title: playlist ? playlist.title : "" }}
        enableReinitialize
        onSubmit={(values, actions) => {
          editPlaylist(playlist._id, { title: values.title })
            .then(() => {
              actions.setSubmitting(false);
              dispatch(updatePlaylistAction({ ...playlist, title: values.title }));
              onCloseModal();
            })
            .catch(() => {
              actions.setSubmitting(false);
              actions.setFieldError("title", "Something went wrong");
            });
        }}
        validate={(values) => {
          let errors = {};
          if (!values.title) {
            errors.title = "Required";
          } else if (values.title.length > 20) {
            errors.title = "You have exceeded max number of characters";
          }
          return errors;
        }}
        render={(props) => (
          <Form className="content">
            <Input
              className="input"
              label="PLAYLIST NAME"
              limit={20}
              isFormikField
              name="title"
              setAutofocus
            />
            <div className="buttons-wrapper">
              <div className="button button--back" onClick={onCloseModal}>
                CANCEL
              </div>
              <button
                className={cn("button button--continue", {
                  disabled: props.isSubmitting || !props.isValid,
                })}
                type="submit"
              >
                SAVE
              </button>
            </div>
          </Form>
        )}
      />
    </Modal>
  );
};

export default RenamePlaylistModal;
